function extractErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message: unknown }).message);
  }
  return String(error ?? '');
}

const CHUNK_LOAD_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Loading chunk [\da-zA-Z_-]+ failed/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
  /ChunkLoadError/i,
];

export function isChunkLoadError(error: unknown): boolean {
  const message = extractErrorMessage(error);
  return CHUNK_LOAD_PATTERNS.some((pattern) => pattern.test(message));
}

export function isChunkScriptUrl(url: string): boolean {
  return /\.(js|mjs)(\?|$)/i.test(url);
}
